/**
 * Environment Configuration
 * Centralized configuration for all environment variables
 */

const config = {
  // API Configuration
  api: {
    baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api',
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
  },

  // Internationalization
  i18n: {
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  },

  // Authentication
  auth: {
    defaultAuth: process.env.VUE_APP_DEFAULT_AUTH || 'fakebackend',
  },

  // Firebase Configuration (if using Firebase)
  firebase: {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTId,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPId,
    measurementId: process.env.VUE_APP_MEASUREMENTID,
  },

  // Environment detection
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',

  // Feature flags
  features: {
    enableAnalytics: process.env.VUE_APP_ENABLE_ANALYTICS === 'true',
    enableDebugMode: process.env.VUE_APP_DEBUG_MODE === 'true',
  },
};

export default config; 